import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'arrayToString',
    pure: false,
})
export class ArrayToStringPipe implements PipeTransform {
    transform(dataArray: unknown[], propertyName?: string, separator = ', '): string {
        let arrayOfStrings: string[];
        if (propertyName) {
            arrayOfStrings = dataArray.map((item) => item[propertyName]);
        } else {
            arrayOfStrings = dataArray as string[];
        }

        arrayOfStrings = arrayOfStrings.filter((value) => {
            return !!value;
        });

        return arrayOfStrings.join(separator);
    }
}
